/**
 * File to set containers and props on load
 */

import AuditStream from "../pages/reporting/audit/AuditStream";
import IncidentStream from "../pages/reporting/incident-report/IncidentStream";
import LessonLearnedStream from "../pages/lesson-learned/LessonLearnedStream";
import MocStream from "../pages/reporting/moc/MocStream";
import OfiStream from "../pages/reporting/ofi/OfiStream";
import NonConformanceStream from "../pages/reporting/non-conformance/NonConformanceStream";
import AdminPage from "../containers/admin/AdminPage";
import Audits from "../containers/Audits";
import Dashboard from "../containers/Dashboard";
import MultiAssetPhaseContainer from "../containers/MultiAssetPhaseContainer";
import MyTasks from "../containers/MyTasks";
import OperationSettings from "../containers/OperationSettings";
import Overview from "../containers/Overview";
import PhaseOverview from "../containers/PhaseOverview";
import Profile from "../containers/Profile";
import ProjectCampaignOverview from "../containers/ProjectCampaignOverview";
import Projects from "../containers/Projects";
import ProjectSettings from "../containers/ProjectSettings";
import PWellOverview from "../containers/PWellOverview";
import Reporting from "../pages/reporting/Reporting";
import ReportOverview from "../pages/reporting/ReportOverview";
import SharepointPreview from "../containers/SharepointPreview";
import TaskOverview from "../containers/TaskOverview";
import TenantConfig from "../containers/TenantConfig";
import TimewritingRevamp from "../containers/TimewritingRevamp";
import WellDetails from "../containers/WellDetails";
import WellOverview from "../containers/WellOverview";
import WellProgrammeTemplate from "../containers/WellProgrammeTemplate";
import { TimewritingProvider } from "../contexts/TimewritingContext";

import ModuleRoles from "../pages/admin-page/tenant-management/ModuleRoles";

export const containerList = [];

export const adminContainerList = [];

export const setContainer = (component: any, params: any) => {
	switch (component) {
		case "dashboard":
			return <Dashboard />;
		case "dashboard-project-map":
			return <Overview params={params} />;
		case "projects":
			return <Projects />;
		case "projectCampaignOverview":
			return <ProjectCampaignOverview params={params} />;
		case "WellOverview":
			return <WellOverview params={params} />;
		case "OperationSettings":
			return <OperationSettings params={params} />;
		case "projectSettings":
			return <ProjectSettings params={params} />;
		case "profile":
			return <Profile params={params} />;
		case "admin":
			return <AdminPage params={params} />;
		case "wellProgrammeTemplate":
			return <WellProgrammeTemplate params={params} />;
		case "PhaseOverview":
			return <PhaseOverview params={params} />;
		case "TaskOverview":
			return <TaskOverview params={params} />;
		case "wells":
			return <PWellOverview params={params} />;
		case "wellDetails":
			return <WellDetails params={params} />;
		case "sharepointPreview":
			return <SharepointPreview />;
		case "wellExaminationPreview":
			return <SharepointPreview mode="well-examination" />;
		case "lesson-learned-stream":
			return <LessonLearnedStream />;
		case "audits":
			return <Audits params={params} />;
		case "auditStream":
			return <AuditStream />;
		case "incidentStream":
			return <IncidentStream />;
		case "mocStream":
			return <MocStream />;
		case "ofiStream":
			return <OfiStream />;
		case "ncrStream":
			return <NonConformanceStream />;
		case "reportOverview":
			return <ReportOverview />;
		case "timewriting":
			return (
				<TimewritingProvider>
					<TimewritingRevamp />
				</TimewritingProvider>
			);
		case "multi-asset":
			return <MultiAssetPhaseContainer params={params} />;
		case "tenant-configuration":
			return <TenantConfig params={params} />;
		case "reporting":
			return <Reporting />;
		case "my-reports":
			return <Reporting initialTab="my-reports" />;
		case "my-tasks":
			return <MyTasks params={params} />;
		case "moduleRoles":
			return <ModuleRoles />;
	}
};
